import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

interface LogoProps {
  variant?: "light" | "primary";
}

export const Logo = styled((props: LogoProps) => {
  const { variant, ...other } = props;

  const color = variant === "light" ? "#ffffff" : "#333333";

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      enableBackground="new 0 0 145.667 34"
      xmlSpace="preserve"
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M65.916,25.546h-9.814V9.02h9.814v3.588h-5.351V15.2h4.953v3.588
      h-4.953v3.125h5.351V25.546L65.916,25.546z M84.267,17.264c0,2.781-0.679,4.895-2.044,6.342c-1.362,1.447-3.36,2.172-5.991,2.172
      c-2.593,0-4.579-0.729-5.964-2.184c-1.381-1.454-2.072-3.572-2.072-6.35c0-2.75,0.687-4.853,2.064-6.304
      c1.373-1.45,3.372-2.175,5.995-2.175c2.631,0,4.622,0.721,5.98,2.16C83.592,12.364,84.267,14.479,84.267,17.264L84.267,17.264z
       M72.899,17.26c0,3.195,1.111,4.792,3.333,4.792c1.13,0,1.971-0.39,2.515-1.165c0.548-0.775,0.821-1.983,0.821-3.626
      c0-1.651-0.277-2.87-0.833-3.657c-0.552-0.787-1.381-1.181-2.481-1.181C74.017,12.422,72.899,14.035,72.899,17.26L72.899,17.26z
       M98.004,25.546l-2.075-9.421l-2.045,9.421h-4.648l-3.491-12.8h4.352l1.625,8.118l1.866-8.118h4.884l1.951,8.338l1.56-8.338h4.263
      l-3.515,12.8H98.004L98.004,25.546z M112.498,25.546h-4.421v-12.8h4.421V25.546L112.498,25.546z M123.666,25.546v-6.982
      c0-0.853-0.124-1.494-0.366-1.929c-0.248-0.432-0.641-0.648-1.185-0.648c-0.745,0-1.285,0.297-1.616,0.891
      c-0.332,0.598-0.498,1.617-0.498,3.063v5.605h-4.417v-12.8h4.427l-0.007,1.153c1.013-1.239,2.317-1.385,3.593-1.385
      c1.417,0,2.52,0.409,3.307,1.23c0.787,0.821,1.181,1.979,1.181,3.472v8.329H123.666L123.666,25.546z M131.096,22.703
      c-0.375-1.01-0.56-2.191-0.56-3.542c0-3.207,0.82-5.859,4.246-6.573c1.387-0.289,2.885-0.152,3.824,0.578l-0.003-5.211h4.32v17.591
      l-4.319,0.015l0-0.618C137.314,26.534,132.331,26.04,131.096,22.703L131.096,22.703z M136.875,22.283
      c0.71,0,1.208-0.224,1.498-0.667c0.651-1,0.63-3.865-0.016-4.818c-0.324-0.478-0.833-0.717-1.523-0.717
      c-0.583,0-1.03,0.274-1.351,0.818c-0.32,0.547-0.482,1.327-0.482,2.334c0,0.995,0.162,1.751,0.486,2.272
      C135.811,22.024,136.273,22.283,136.875,22.283L136.875,22.283z M47.021,14.293c-0.336-0.255-0.505-0.548-0.505-0.872
      c0-0.301,0.131-0.555,0.398-0.76c0.262-0.204,0.687-0.309,1.265-0.309c1.089,0,2.376,0.335,3.865,1
      c0.011,0.005,0.103,0.049,0.236,0.114V9.475c-1.342-0.458-2.665-0.687-3.966-0.687c-1.937,0-3.46,0.424-4.567,1.276
      c-1.107,0.853-1.659,2.042-1.659,3.562c0,0.813,0.131,1.519,0.39,2.114c0.258,0.594,0.659,1.123,1.195,1.582
      c0.541,0.459,1.346,0.934,2.423,1.423c1.192,0.536,1.925,0.891,2.199,1.064c0.274,0.174,0.474,0.344,0.598,0.514
      c0.127,0.169,0.189,0.366,0.189,0.594c0,0.359-0.154,0.656-0.463,0.884c-0.309,0.227-0.794,0.343-1.458,0.343
      c-0.768,0-1.612-0.124-2.53-0.366c-0.918-0.248-1.806-0.587-2.654-1.022v3.981c0.806,0.386,1.581,0.656,2.326,0.81
      c0.745,0.154,1.67,0.231,2.77,0.231c1.315,0,2.465-0.22,3.445-0.66c0.979-0.444,1.728-1.061,2.249-1.855
      c0.521-0.794,0.779-1.705,0.779-2.731c0-1.115-0.278-2.037-0.829-2.774c-0.556-0.733-1.543-1.424-2.967-2.064
      C48.263,15.014,47.356,14.548,47.021,14.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DA00C8"
        d="M110.288,9.751c1.537,0,2.791-1.253,2.791-2.79
      c0-1.537-1.253-2.791-2.791-2.791s-2.791,1.254-2.791,2.791C107.497,8.498,108.75,9.751,110.288,9.751z"
      />
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#DA00C8"
          d="M17.982,10.086c-1.651-0.484-3.398-0.744-5.206-0.744
      c-2.887,0-5.62,0.663-8.054,1.844c-0.899,1.983-1.4,4.187-1.4,6.506c0,5.873,3.208,10.996,7.968,13.713
      c5.188-2.358,8.796-7.586,8.796-13.656C20.086,14.95,19.318,12.329,17.982,10.086z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#9800E9"
          d="M4.722,11.187c2.434-1.182,5.167-1.844,8.054-1.844
      c1.808,0,3.555,0.26,5.206,0.744c-1.582-2.654-3.959-4.778-6.804-6.042C8.351,5.689,6.081,8.188,4.722,11.187z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#6A00FF"
          d="M11.178,4.044c2.844,1.265,5.222,3.389,6.804,6.042
      c7.653,2.244,13.245,9.308,13.266,17.682c2.27-2.733,3.634-6.245,3.634-10.075c0-8.715-7.065-15.78-15.78-15.78
      C16.214,1.913,13.507,2.689,11.178,4.044z"
        />
      </g>
    </svg>
  );
})``;

Logo.defaultProps = {
  variant: "primary",
};

Logo.propTypes = {
  variant: PropTypes.oneOf(["light", "primary"]),
};
